import React from 'react';
import SiteHeader from 'components/SiteHeader';
import { Link } from 'react-router-dom';

export default function MesafeliSatis() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <div className="h-16 md:h-20"></div>

      <main className="container mx-auto max-w-4xl px-4 py-12 md:py-16">
        
        <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-neutral-900 mb-6 text-center">
          Mesafeli Satış Sözleşmesi
        </h1>

        <div className="space-y-8 text-neutral-800 leading-relaxed text-base">
          
          <h2 className="text-xl font-bold text-neutral-900">MADDE 1 – TARAFLAR</h2>
          
          <section>
            <h3 className="text-lg font-semibold text-neutral-800 mb-2">1.1. SATICI BİLGİLERİ</h3>
            <p className="text-sm font-medium">Unvanı: ANORA FOREVER </p>
            <ul className="list-disc list-inside space-y-1 pl-4 text-sm">
              <li>Adres: SULTAN SELİM MAH. ESKİ BÜYÜKDERE CAD. NO: 61 İÇ KAPI NO: 2 KAĞITHANE/İSTANBUL</li>
              <li>Telefon: +90 554 698 31 44</li>
              <li>E-posta: info@anoraforever.com</li>
              <li>Mersis No: 0070123001700001</li>
              <li>Vergi Dairesi/No: MASLAK/701230017</li>
            </ul>
          </section>
          
          <section>
            <h3 className="text-lg font-semibold text-neutral-800 mb-2">1.2. ALICI BİLGİLERİ</h3>
            <p className="text-sm border-l-2 border-neutral-300 pl-3 italic">
              Alıcı; adı, soyadı, telefon numarası, e-posta bilgileri ve fatura/teslimat adresi ile siparişin verildiği esnada bildirdiği kişi/kurumdur. Bu bilgiler, ödeme ekranında Alıcı tarafından eksiksiz olarak doldurulacaktır.
            </p>
          </section>
          
          <h2 className="text-xl font-bold text-neutral-900 pt-4">MADDE 2 – SÖZLEŞME KONUSU HİZMET</h2>
          <p>
            İşbu Sözleşme'nin konusu, Alıcı'nın Satıcı'ya ait internet sitesinden elektronik ortamda siparişini verdiği, aşağıda nitelikleri ve satış fiyatı belirtilen dijital hizmetin satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerini düzenlenmesidir.
          </p>
          
          <h2 className="text-xl font-bold text-neutral-900 pt-4">MADDE 3 – ÜRÜN/HİZMETİN TEMEL NİTELİKLERİ VE FİYATI</h2>
          <ul className="list-disc list-inside space-y-2 pl-4 text-sm">
            <li>Hizmetin Tanımı: Anora Forever Dijital Etkinlik Albümü - [Seçilen Paket Adı]</li>
            <li>Süre: [Örn: 1 Yıl]</li>
            <li>Adet: 1 (Bir)</li>
            <li>KDV Dahil Satış Fiyatı: Sipariş özetinde belirtilen tutardır.</li>
            <li>Ödeme Şekli: Kredi Kartı / Banka Kartı ile ödeme entegrasyonu sağlanan altyapı firması aracılığıyla yapılacaktır.</li>
          </ul>
          
          <h2 className="text-xl font-bold text-neutral-900 pt-4">MADDE 4 – CAYMA HAKKI İSTİSNASI (Dijital Hizmet)</h2>
          <p className="font-semibold text-neutral-800">
            Alıcı'nın Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi uyarınca cayma hakkı bulunmamaktadır.
          </p>
          <p className="text-sm italic">
            Yönetmeliğin 15. Maddesi'nin (ğ) bendi gereğince; "Elektronik ortamda anında ifa edilen hizmetler veya tüketiciye anında teslim edilen gayrimaddi mallara ilişkin sözleşmelerde cayma hakkı kullanılamaz." Anora Forever hizmetleri, ödeme sonrası anında ifa edilen dijital hizmet kapsamında olduğundan, Alıcı cayma hakkını kullanamayacağını kabul, beyan ve taahhüt eder.
          </p>
          <p className="pt-3">
             Ancak, Satıcı'nın <Link to="/teslimat-iade-sartlari" className="text-rose-600 hover:underline">Teslimat ve İade Şartları</Link> sayfasında belirtilen özel iade politikası hükümleri saklıdır.
          </p>
          
          <h2 className="text-xl font-bold text-neutral-900 pt-4">MADDE 5 – GENEL HÜKÜMLER</h2>
          <ul className="list-disc list-inside space-y-2 pl-4 text-sm">
            <li>Alıcı, Madde 3’te belirtilen sözleşme konusu hizmetin temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin tüm ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini kabul eder.</li>
            <li>Sözleşme konusu hizmetin ifası, ödemenin başarılı bir şekilde tamamlanması ile anında gerçekleşir.</li>
            <li>Satıcı, sözleşme konusu hizmetin sağlam, eksiksiz, siparişte belirtilen niteliklere uygun şekilde teslim edilmesinden sorumludur.</li>
          </ul>

          <h2 className="text-xl font-bold text-neutral-900 pt-4">MADDE 6 – YETKİLİ MAHKEME</h2>
          <p>
            İşbu Sözleşme'den doğan uyuşmazlıklarda, T.C. Gümrük ve Ticaret Bakanlığı tarafından her yıl belirlenen parasal sınırlar dahilinde Alıcı'nın yerleşim yerindeki **Tüketici Hakem Heyetleri** veya **Tüketici Mahkemeleri** yetkilidir.
          </p>
          
        </div>
      </main>
      
    </div>
  );
}